import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { InvalidErrorStateMatcher } from 'src/app/shared/utils/errorstate-matcher';
import { DynamicFormHelper } from '../dynamic-form-heplers/dynamic-form-helper';
import { IDynamicFormField, SelectMenuOption, SelectMenuOptions, SelectMenuOptionsArray } from '../dynamic-form-heplers/dynamic-form-vm';
import { DateFieldComponent } from '../../../../default/employees/add-employee/shared/individual-form/date/date-field.component';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { AsyncPipe, KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-dynamic-form-child',
  templateUrl: './dynamic-form-child.component.html',
  styleUrls: ['./dynamic-form-child.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, DateFieldComponent, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatError, AsyncPipe, KeyValuePipe],
})
export class DynamicFormChildComponent implements OnInit {
  private rootFormDirective = inject(FormGroupDirective);

  @Input() public formItem: IDynamicFormField;
  @Input() public errorState: InvalidErrorStateMatcher;

  public errorTypes$ = new BehaviorSubject<string[]>([]);
  public f!: UntypedFormGroup;
  public control: UntypedFormControl;

  public selectOptions: SelectMenuOptions;

  public ngOnInit(): void {
    this.f = this.rootFormDirective.control;
    this.control = this.f.get(this.formItem.id) as UntypedFormControl;
    if (this.control.invalid && this.control.errors.required) {
      this.formItem.errorTextObj = {
        ...this.formItem.errorTextObj,
        required: `${this.formItem.label} is required.`,
      };
    }
    if (this.formItem.type === 'select') {
      this.selectOptions = (this.formItem.preserveSelectOrdering ? DynamicFormHelper.convertToArray : DynamicFormHelper.convertToMap)(this.formItem.selectMenuOptions);
    }
  }

  public isSelectOptionsArray(_selectOptions: SelectMenuOptions): _selectOptions is SelectMenuOptionsArray {
    return this.formItem.preserveSelectOrdering;
  }

  public checkErrors(): void {
    if (this.control.invalid) {
      if (!this.control.value || this.control.errors.required) {
        this.errorTypes$.next(['required']);
      } else {
        this.errorTypes$.next(Object.keys(this.control.errors));
      }
    } else {
      this.errorTypes$.next([]);
    }
  }

  public valueChanges(value: string): void {
    if (this.formItem.valueChanges) {
      this.formItem.valueChanges(value);
    }
  }

  public getMatOptionValue(option: SelectMenuOption | string): string {
    return typeof option === 'string' ? option : option.value;
  }

  public getMatOptionDisabled(option: SelectMenuOption | string): boolean {
    return typeof option === 'string' ? false : option.disabled;
  }

  public getDisabledReasons(): string {
    if (!this.formItem.disabledReason) {
      return;
    }
    const optionValues = Object.values(this.formItem.selectMenuOptions).filter((option) => typeof option !== 'string') as SelectMenuOption[];

    const values = optionValues
      .filter((option) => option.disabled)
      .map((option) => option.value)
      .join(', ');
    return values.length ? this.formItem.disabledReason.replace('${values}', values) : undefined;
  }
}
